import React from 'react';
import SearchRow from './SearchRow';
import RecommendedRow from './RecommendedRow';
import PropTypes from 'prop-types';
import NoResultModal from './NoResultModal';

const Modal = props => {
  const {
    fptiClick,
    fptiImpression,
    toolTileProps,
    featured,
    appSearch: { query = '', results } = {},
    content
  } = props;

  const {
    flatPSData: { recommended = [], isNewLayoutEligible } = {}
  } = toolTileProps;

  if (query.length <= 1) {
    return null;
  }

  const categoryPageLink = 'search_modal_recommendation';

  return (
    <div
      onClick={e => e.stopPropagation()}
      id="appcenter-modal"
      aria-hidden="true"
    >
      <div
        style={{ backgroundColor: '#F7F5F0', padding: '60px' }}
        id="appcenter-categories"
      >
        {results && results.length > 0 ? (
          <SearchRow {...props} />
        ) : (
          <NoResultModal fptiClick={fptiClick} content={content} />
        )}
      </div>
      <div
        id="appcenter-categories"
        className={isNewLayoutEligible ? 'mobile-bkg' : ''}
        style={{
          backgroundColor: '#FFFFFF',
          paddingLeft: '60px',
          paddingRight: '60px'
        }}
      >
        <RecommendedRow
          content={recommended[0]}
          featured={featured}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
          largeTile={false}
          categoryPageLink={categoryPageLink}
        />
      </div>
    </div>
  );
};

Modal.propTypes = {
  featured: PropTypes.array,
  toolTileProps: PropTypes.object,
  experimentation: PropTypes.object,
  content: PropTypes.object,
  appSearch: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func
};

export default Modal;
